<template>
  <v-container>
    <v-row class="pt-1">
      <h3>Notes</h3>
    </v-row>
    <v-row>
      <v-col cols="12">
        <input-handler :path="`${path}.buildingNotes`" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "BuildingNotes",

  props: {
    buildingIndex: String,
  },

  computed: {
    path() {
      return `buildings[${this.buildingIndex}].notes`
    },
  },

  components: {
    InputHandler: () =>
      import(
        /* webpackChunkName: 'InputHandler' */
        "@/components/input/InputHandler"
      ),
  },
}
</script>
